import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { ShieldAlert, Sparkles, CreditCard } from "lucide-react";

export function TrialExpiredBlock() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <Card className="max-w-lg w-full border-destructive/30 bg-destructive/5">
        <CardContent className="pt-8 pb-8 text-center space-y-6">
          <div className="mx-auto w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <ShieldAlert className="w-8 h-8 text-destructive" />
          </div>

          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-foreground">
              Your Free Trial Has Ended
            </h2>
            <p className="text-muted-foreground max-w-sm mx-auto">
              Your 14-day free trial has expired. Subscribe to a plan to continue using all Outsprinter features.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/pricing">
              <Button size="lg" className="gap-2 w-full sm:w-auto">
                <Sparkles className="w-4 h-4" />
                View Plans & Subscribe
              </Button>
            </Link>
            <Link to="/billing">
              <Button size="lg" variant="outline" className="gap-2 w-full sm:w-auto">
                <CreditCard className="w-4 h-4" />
                Subscription Status
              </Button>
            </Link>
          </div>

          <p className="text-xs text-muted-foreground">
            Need help? <Link to="/contact" className="underline hover:text-foreground">Contact our team</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
